import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useElementQuerySelector } from '@/hooks/useElementQuerySelector';

import { loaderPortalId } from './loader-portal-id';

type LoaderPortalProps = {
  targetId: string;
  children: ReactNode;
};

export const LoaderPortal = ({ targetId, children }: LoaderPortalProps) => {
  const portal = useElementQuerySelector(`#${loaderPortalId(targetId)}`);

  if (!portal) return null;

  return createPortal(
    <div className="text-reasoning-accent motion-opacity-in-0 motion-duration-300 flex items-center gap-2">
      <div className="size-6 shrink-0">{children}</div>
    </div>,
    portal
  );
};
